import React from 'react';
import CategoryQuotaDetails from './CategoryQuotaDetails';

const number = (value) => value.toLocaleString('fr-FR');
const QuotaDistributionChart = ({ quota }) => (
  <>
    <div className="mb-5 grid items-center gap-6 sm:grid-cols-[150px_minmax(0,1fr)_190px] sm:gap-[30px]">
      <div>
        <p className="text-[44px] font-semibold leading-tight tracking-[-1.5px] text-emerald-800">
          {number(quota.occupied)}
        </p>
        <p className="mt-1 text-sm text-slate-600">Pèlerins soldés</p>
      </div>
      <div>
        <div className="mb-2 flex justify-between gap-2 text-xs text-slate-500">
          <span>{number(quota.occupied)} places occupées</span>
          <strong className="text-emerald-800">
            {quota.total > 0
              ? `${((quota.occupied / quota.total) * 100).toLocaleString('fr-FR', {
                  maximumFractionDigits: 1,
                  minimumFractionDigits: 1,
                })} %`
              : '—'}
          </strong>
        </div>
        <div className="h-2.5 overflow-hidden rounded-[3px] bg-slate-100" aria-hidden="true">
          <div
            className="h-full bg-emerald-700"
            style={{ width: `${quota.total > 0 ? Math.min(100, (quota.occupied / quota.total) * 100) : 0}%` }}
          />
        </div>
        <div className="mt-1 flex justify-between text-xs text-slate-500">
          <span>0</span>
          <span>{number(quota.total)} places</span>
        </div>
      </div>
      <div className="sm:text-right">
        {quota.available <= 0 && <p className="mb-2 text-xs font-semibold text-red-700">Quota atteint</p>}
        <p className="text-[44px] font-semibold leading-tight tracking-[-1.5px] text-emerald-700">
          {number(quota.available)}
        </p>
        <p className="mt-1 text-sm text-slate-600">places disponibles</p>
        <p className="mt-1 text-xs text-slate-500">sur {number(quota.total)}</p>
      </div>
    </div>
    <div className="grid gap-x-6 gap-y-[18px] border-t pt-4 sm:grid-cols-2 xl:grid-cols-3">
      {quota.categories.map((category) => (
        <CategoryQuotaDetails key={category.id} category={category} className="min-w-0" />
      ))}
    </div>
  </>
);
export default QuotaDistributionChart;
